import { render } from "./modalVideo.vue?vue&type=template&id=59bca031&scoped=true"
import script from "./modalVideo.vue?vue&type=script&lang=js"
export * from "./modalVideo.vue?vue&type=script&lang=js"

import "./modalVideo.vue?vue&type=style&index=0&id=59bca031&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bca031"]])

export default __exports__